import { createContext } from 'react'

const FormContext = createContext(null)

export const FormContextProvider = FormContext.Provider
export default FormContext
